// Shared icon map for allergens and dietary preferences.
// Used by MenuGrid (item detail modal) and UserSidebar (filter checkboxes)
// so icons stay consistent across the app.
const dietaryIcons = {
  Vegetarian: '🥬',
  Vegan: '🌱',
  Gluten: '🌾',
  Dairy: '🥛',
  Eggs: '🥚',
  Fish: '🐟',
  Shellfish: '🦐',
  Soy: '🫘',
  Sesame: '🌰',
  Halal: '☪️',
  Pork: '🐷',
  Spicy: '🌶️',
};

export default dietaryIcons;